<template>
<div>
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a @click="$router.push('/home')" class="navbar-item">
                <img id="nav-logo" :src="`${publicPath}img/logo.png`" alt="eWATER Services">
            </a>
            <a @click="toggleMenu()" role="button" class="navbar-burger burger" :class="{ 'is-active': navbarVisible }" aria-label="menu" aria-expanded="false" data-target="offcanvasMenu">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
            </a>
        </div>
        <div id="offcanvasMenu" class="navbar-menu noselect" :class="{ 'is-active': navbarVisible }">
            <div class="navbar-start">
                <p class="navbar-item has-text-centered">
                    <span class="has-text-primary has-text-weight-bold">{{ user.name }} ({{ user.role }})</span>
                </p>
                <a @click="logout()" class="navbar-item">
                    <span class="icon">
                        <i class="fa fa-sign-out"> </i>
                    </span>
                    <span>{{ $t("Logout") }}</span>
                </a>
                <p class="navbar-item has-text-centered">
                    <span class="has-text-grey-light is-size-7">{{ $t("Version") }}: {{ version }}</span>
                </p>
            </div>
        </div>
    </nav>
    <div id="banner" class="columns is-mobile is-centered has-text-centered no-margin-bottom">
        <div class="column is-size-7 online-only">
            <span class="icon">
                <i class="fa fa-money"> </i>
            </span>
            <span>{{ $t("Online") }}: {{ availableCredits }}</span>
        </div>
        <div class="column is-size-7">
          <div class="columns">
            <div class="column is-fullwidth">
              <div class="control has-icons-left">
                <div class="select is-pulled-right" style="margin-right:24px;">
                  <select v-model="language" @change="switchLanguage()">
                    <option selected value="disabled" disabled>{{ $t("Language") }}</option>
                    <option value="en">{{ $t("English") }}</option>
                    <option value="sw">{{ $t("Swahili") }}</option>
                  </select>
                  <div class="icon is-small is-left is-pulled-right">
                    <i class="fa fa-flag"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "Header",
  data () {
      return {
          navbarVisible: false,
          language: "disabled"
      }
  },
  computed:
  {
    availableCredits: function()
    {
        if(this.user && this.user.wallet)
        {
            return this.showCurrency(this.user.wallet.credits, this.user.wallet.currency)
        }

        return null;
    }
  },
  methods: {
    toggleMenu: function() {
        this.navbarVisible = !this.navbarVisible;
    },
    switchLanguage: function()
    {
      this.updateTranslations(this.language);
    }
  }
};
</script>